"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConsentSettings = void 0;
function updateConsentSettings(consentSettings) {
    window.gtag("consent", "update", consentSettings);
}
exports.updateConsentSettings = updateConsentSettings;
